(() => {
  if (window.PraTeeCartNotificationBridgeInitialized) return;
  window.PraTeeCartNotificationBridgeInitialized = true;

  const collectPersonalizationProperties = () => {
    const properties = {};

    document.querySelectorAll('.tee-form-wrapper .tee-field, .tee-customize-main-form .tee-field').forEach((field) => {
      const heading = field.querySelector('.tee-field__heading, .tee-field-heading, legend');
      const propertyName = heading?.textContent?.replace(/\*/g, '').replace(/\s+/g, ' ').trim();
      if (!propertyName) return;

      const values = [];
      field.querySelectorAll('input:checked').forEach((option) => {
        const label = option.id ? field.querySelector(`label[for="${CSS.escape(option.id)}"]`) : null;
        values.push(label?.textContent?.trim() || option.value);
      });
      field
        .querySelectorAll(
          '.tee-radio.active label, .tee-clipart.active label, .tee-swatch.active label, [role="option"].active, [aria-selected="true"]'
        )
        .forEach((option) => {
          values.push(
            option.dataset?.title ||
              option.querySelector('img')?.alt ||
              option.textContent?.trim()
          );
        });
      field.querySelectorAll('select').forEach((select) => {
        values.push(select.selectedOptions[0]?.textContent?.trim() || select.value);
      });
      field
        .querySelectorAll('input:not([type="radio"]):not([type="checkbox"]):not([type="file"]):not([type="hidden"]), textarea')
        .forEach((input) => values.push(input.value?.trim()));
      field.querySelectorAll('input[type="file"]').forEach((input) => {
        Array.from(input.files || []).forEach((file) => values.push(file.name));
      });

      const hasUploadedPhoto = field.querySelector(
        '.tee-photo-preview img[src], .tee-photo-preview-history img[src], .tee-photo-input img[src]'
      );
      if (hasUploadedPhoto && !values.some((value) => /\.(jpe?g|png|webp|gif|heic)$/i.test(value || ''))) {
        values.push('Imagem enviada');
      }

      field.querySelectorAll('.tee-clipart.active img, [aria-selected="true"] img').forEach((image) => {
        values.push(image.alt || image.title);
      });

      const propertyValue = [...new Set(values.map((value) => value?.replace?.(/\s+/g, ' ').trim()).filter(Boolean))].join(', ');
      if (propertyValue) properties[propertyName] = propertyValue;
    });

    return properties;
  };

  const previousTransform = window.teeinblue?.transformBeforeAddToCart;
  window.teeinblue = window.teeinblue || {};
  window.teeinblue.transformBeforeAddToCart = async (payload) => {
    const transformedPayload =
      typeof previousTransform === 'function' ? await previousTransform(payload) : payload;
    const result = transformedPayload || payload;

    return {
      ...result,
      properties: {
        ...(result.properties || {}),
        ...collectPersonalizationProperties(),
      },
    };
  };

  let syncPromise = null;
  let syncTimer = null;
  let lastSuccessText = '';

  const renderCurrentCart = async () => {
    if (syncPromise) return syncPromise;

    syncPromise = (async () => {
      try {
        const cartUi = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cartUi || typeof cartUi.renderContents !== 'function') return;

        const cartUrl = window.routes?.cart_url || '/cart';
        const cartResponse = await fetch(`${cartUrl}.js`, {
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!cartResponse.ok) throw new Error(`Cart request failed: ${cartResponse.status}`);

        const cart = await cartResponse.json();
        const addedItem = cart.items?.[0];
        if (!addedItem) return;

        const sectionIds = cartUi.getSectionsToRender().map((section) => section.id);
        const sectionsResponse = await fetch(`${cartUrl}?sections=${sectionIds.join(',')}`, {
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!sectionsResponse.ok) throw new Error(`Cart sections request failed: ${sectionsResponse.status}`);

        const sections = await sectionsResponse.json();
        cartUi.renderContents({ id: addedItem.variant_id, key: addedItem.key, sections });
      } catch (error) {
        console.error('Unable to update the Shopify cart notification after TeeInBlue add to cart.', error);
      } finally {
        syncPromise = null;
      }
    })();

    return syncPromise;
  };

  const scheduleRender = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(renderCurrentCart, 300);
  };

  document.addEventListener('teeinblue-event-after-cart-added', scheduleRender);

  new MutationObserver(() => {
    const successText = document.querySelector('.tee-form-responses .tee-success')?.textContent?.trim() || '';
    if (!successText || successText === lastSuccessText) return;
    lastSuccessText = successText;
    scheduleRender();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
